import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "../environments/environment";
import { Helpers } from "../helpers/helpers";
import { catchError } from "rxjs/operators";
import { ICountService } from "./icount.service";
import { NewCustomer } from "src/models/newcustomer";
import { AccountService } from "./account.service";
import { Router } from "@angular/router";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";

@Injectable({
  providedIn: "root",
})
export class RenewComprehensiveCustomerService
  extends BaseService
  implements ICountService
{
  private pathAPI = environment.apiUrl;

  public errorMessage: string;

  constructor(
    private http: HttpClient,
    helper: Helpers,
    private accountService: AccountService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {
    super(helper);
    const userType = this.helper.getDecodedAccessToken(
      window.localStorage.token
    ).type;
    if (
      userType.indexOf("LEVEL 0") === 0 ||
      userType.indexOf("LEVEL 1") === 0 ||
      userType.indexOf("LEVEL 2") === 0
    ) {
      this.accountService.getAccount().subscribe((data) => {
        if (!data.activated) {
          this.helper.logout();
          this.router.navigate(["/"]);
          this.snackBar.open(
            "Your account is not active, please contact admin.",
            "Close",
            {
              duration: 3000,
            }
          );
        }
      });
    }
  }

  getData(body: any): any {
    return this.http
      .post<any>(
        this.pathAPI + "Account/GetRenewComprehensiveCustomers",
        body,
        super.header()
      )
      .pipe(catchError(super.handleError));
  }

  getCount(body: any): any {
    return this.http
      .post<any>(
        this.pathAPI + "Account/GetRenewComprehensiveCustomersCount",
        body,
        super.header()
      )
      .pipe(catchError(super.handleError));
  }

  get(id: number): any {
    return this.http
      .get<NewCustomer>(
        this.pathAPI + "Account/GetRenewComprehensiveCustomer/" + id,
        super.header()
      )
      .pipe(catchError(super.handleError));
  }

  update(id: number, customer: NewCustomer): any {
    return this.http
      .put<any>(
        this.pathAPI + "Account/RenewComprehensiveCustomer/" + id,
        customer,
        super.header()
      )
      .pipe(catchError(super.handleError));
  }

  sendComprehensiveLink(body: any, lang?: string): any {
    return this.http
      .post<any>(
        this.pathAPI + "Account/SendComprehensivePolicyRenewalSMS",
        body,
        super.header(null, lang)
      )
      .pipe(catchError(super.handleError));
  }
}
